import { Component, Inject, type OnInit } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import { type VehicleDTOExtended } from '../../../services/vehicles.service'
import { CallRequestPopupComponent } from '../../vehicle-details/call-request-popup/call-request-popup.component'
import { LocalStorageService } from '../../../services/local-storage.service'
import { EfRemoteConfigurationService } from '@inside-hub-app/ef-remote-config'
import { type CustomerPortalConfig } from '@inside-hub-app/customer-portal-config'
import { MatIcon } from '@angular/material/icon'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { VehiclePickerComponent } from '../vehicle-picker/vehicle-picker.component'
import { MatButtonModule } from '@angular/material/button'
import { TransifexService } from '@inside-hub-app/customer-portal-shared'

@Component({
  selector: 'customer-portal-support-call-popup',
  standalone: true,
  templateUrl: './support-call-popup.component.html',
  imports: [
    MatIcon,
    HubChildTranslateModule,
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButtonModule,
    VehiclePickerComponent
  ]
})
export class SupportCallPopupComponent implements OnInit {
  selectedVehicle: VehicleDTOExtended | null = null
  vehicles: VehicleDTOExtended[] = []
  loading = true
  country: string

  constructor (
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SupportCallPopupComponent>,
    private readonly localStorage: LocalStorageService,
    private readonly remoteConfigService: EfRemoteConfigurationService<CustomerPortalConfig>,
    private readonly transifexService: TransifexService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.country = this.remoteConfigService.get('country.code')
  }

  ngOnInit (): void {
    void this.loadVehicles()
  }

  private async loadVehicles (): Promise<void> {
    this.vehicles = await this.localStorage.getVehicles()
    this.loading = false
  }

  onVehicleSelected (vehicle: VehicleDTOExtended): void {
    this.selectedVehicle = vehicle
  }

  onNext (): void {
    this.dialogRef.close()

    const selectedDealer = this.selectedVehicle?.dealer

    this.dialog.open(CallRequestPopupComponent, {
      data: {
        vehicle: this.selectedVehicle,
        dealer: selectedDealer,
        type: 'dealer'
      },
      panelClass: 'mat-dialog-cpt'
    })
  }

  translateShared (key: string): string {
    const translation = this.transifexService.getSharedTranslation(key)
    return translation || key
  }
}
